const appConfig = {
    apiPrefix: 'https://backend.elzara.in',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    baseURL: "https://backend.elzara.in/assets/"
}

export default appConfig